import { render, staticRenderFns } from "./consigneeInfo.vue?vue&type=template&id=0d4c387e&scoped=true"
import script from "./consigneeInfo.vue?vue&type=script&lang=js"
export * from "./consigneeInfo.vue?vue&type=script&lang=js"
import style0 from "./consigneeInfo.vue?vue&type=style&index=0&id=0d4c387e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4c387e",
  null
  
)

export default component.exports